import axiosPost from "./axiosPost";

export const RNHComponenteSecundarioDel = async (credentials, data) => {
    const body = {
        service: "RNHComponenteSecundarioDel",
        params: {
            rnhComponenteSecundarioId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
